<div class="row" *ngIf="isBasica || isComercial">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>
                <mat-card-content *ngIf="!collapseCard">

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Peso de espigas atípicas (kg)</mat-label>
                                <input matInput id="txtPeso_espigas_atipicas_kg" #txtPeso_espigas_atipicas_kg
                                    maxlength="10" formControlName="Peso_espigas_atipicas_kg" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 1 }"
                                    (blur)="makeCalculations()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtPeso_espigas_atipicas_kg.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Peso_espigas_atipicas_kg)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Peso de espigas fora do padrão (kg)</mat-label>
                                <input matInput id="txtPeso_espigas_fora_padrao_kg" #txtPeso_espigas_fora_padrao_kg
                                    maxlength="10" formControlName="Peso_espigas_fora_padrao_kg" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 1 }"
                                    (blur)="makeCalculations()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtPeso_espigas_fora_padrao_kg.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Peso_espigas_fora_padrao_kg)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <!-- <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Umidade (%)</mat-label>
                                <input matInput id="txtUmidade" #txtUmidade maxlength="10" formControlName="Umidade"
                                    currencyMask [options]="{ thousands: '.', decimal: ',', precision: 1 }"
                                    (blur)="makeCalculations()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtUmidade.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Umidade)}}
                                </mat-error>
                            </mat-form-field>
                        </div> -->
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Peso líquido carga sem palha (kg)
                                </mat-label>
                                <input matInput id="txtPeso_liquido_carga_sem_palha_kg"
                                    #txtPeso_liquido_carga_sem_palha_kg maxlength="10" class="InputBlockColor"
                                    formControlName="Peso_liquido_carga_sem_palha_kg" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 1 }">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtPeso_liquido_carga_sem_palha_kg.value.length}} / 10
                                </mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Peso_liquido_carga_sem_palha_kg)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Peso descarte mesa seleção (kg)
                                </mat-label>
                                <input matInput id="txtPeso_descarte_mesa_selecao_kg" #txtPeso_descarte_mesa_selecao_kg
                                    maxlength="10" formControlName="Peso_descarte_mesa_selecao_kg" readonly
                                    class="InputBlockColor" currencyMask>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtPeso_descarte_mesa_selecao_kg.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Peso_descarte_mesa_selecao_kg)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Descarte da mesa de seleção (%)
                                </mat-label>
                                <input matInput id="txtDescarte_mesa_selecao" #txtDescarte_mesa_selecao maxlength="10"
                                    formControlName="Descarte_mesa_selecao" readonly class="InputBlockColor"
                                    currencyMask>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtDescarte_mesa_selecao.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Descarte_mesa_selecao)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Espigas atípicas (%)
                                </mat-label>
                                <input matInput id="txtEspigas_atipicas" #txtEspigas_atipicas maxlength="10"
                                    formControlName="Espigas_atipicas" readonly class="InputBlockColor" currencyMask>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtEspigas_atipicas.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Espigas_atipicas)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Presença de outras Sementes
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <mat-select #txtPresenca_outras_sementes formControlName="Presenca_outras_sementes"
                                    disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterPresencaSementes($event.target.value)">
                                    <mat-option *ngFor="let item of listPresencaSementes" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Presenca_outras_sementes)}}
                                </mat-error>

                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>

<div class="row" *ngIf="isPreBasica">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>
                <mat-card-content *ngIf="!collapseCard">

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Criado por
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtCriadoPor" #txtCriadoPor maxlength="80"
                                    formControlName="created_by" [readonly]="true" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtCriadoPor.value.length}} / 80</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.created_by)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Responsável Lançamento
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtRespLancamento" #txtRespLancamento maxlength="80"
                                    formControlName="responsavel_lancamento">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="end">{{txtRespLancamento.value.length}} / 80</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.responsavel_lancamento)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>


                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Observação</mat-label>
                                <textarea matInput id="txtObs" #txtObs maxlength="255"
                                    formControlName="observacao"></textarea>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-hint align="end">{{txtObs.value.length}} / 255</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.observacao)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>